import { atom } from 'recoil';

const startZoomLevelState = atom({
    key: 'startZoomLevel',
    default: null
});

export default startZoomLevelState;
